const CustomApis = {
    //gov
    getGovList: '/api/g1o0v-l8i3s2t',
    getGovPage: '/api/g5o8v-p3a7g0e',
    getGovById: '/api/g9o2v',
    saveGov: '/api/g7o5v-s2a8ve',
    delGov: '/api/g6o2v/d2e9l',
    //reg
    getRegList: '/api/r8e2g-l3i6s3t',
    getRegPage: '/api/r0e4g-p5a9g2e',
    getRegById: '/api/r23e61g',
    saveReg: '/api/r6e1g-s0a5v3e',
    delReg: '/api/r0e9g/d41e3l',
    //publish
    searchRegionPublish: '/api/p4ub3l4i2sh-se2a6r34ch-re3g2io64n',
    searchAuditPublish: '/api/p3u4b634li2sh-se2a6rc6h-au56di2t',
    searchAuditPublishYJY: '/api/p3u5b2l65i34sh-s3ea4r5c5h-a2u6di7t-j3yj',
    getPublishById: '/api/p3u4b1l7i4s5h',
    savePublish: '/api/p61ub4l2i6s98h-s2av2e',
    delPublish: '/api/pu5b56l2is5h/d7e522l',
    splitFile: '/api/p3u5b3l56i7s2h/s4p7l8i34t',
    accept: '/api/p67u45b2l6is8h/a12c56c8e3p4t',
    unaccept: '/api/p3u3b54l5i1s34h/un3ac2c32e7pt',
    changeTime: '/api/p4u4b4l2i2s5h/c664h24a2n65ge-t2i7me',
    getPublishCountByType: '/api/p34u2b4l2i5sh/c4o3u5n2t',
    getPublishCountByTypeJYJ: '/api/p5u3bl2i5s3h/c3o44u2nt-j6y7j',
    getPublishByStatus: '/api/p4u5b6l2i6s4h/s3t65a4t6us',
    //settings
    getSettingsList: '/api/s5et7ti6n4gs/l7i3st',
    saveSettings: '/api/se9t1ti4ng34s/sa3v7e',
    delSettings: '/api/se6t523t4in41gs/d6e7l1et5e',
}
const CustomOpenApis = {
    //gov
    getGovById: '/open/api/g3o5v8',
    getGovList: '/open/api/g3o5v-l2i6s732t',
    //reg
    getRegList: '/open/api/r3e5g-l6i77s4t',
    getRegById: '/open/api/r6e25g',
    //publish
    searchPublish: '/open/api/publish-search',
    //settings
    getSettingsList: '/open/api/s56t4ti23n3g5s/l5is6t',
}
export {CustomApis, CustomOpenApis}
